module.exports = __webpack_public_path__ + "static/media/SAIL.e40406a0.txt";